import { ECommerce } from "@omni/components/components/Product/ECommerce/eCommerce";
import { useECommerceProduct } from "@omni/components/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { StickyAction } from "@omni/components/components/StickyAction/stickyAction";
import { getTagIdFor } from "@omni/components/utils/tagging/tag.utils";
import { StickyActionElement } from "@omni/types/components/general/enums/stickyActionElement.enum";
import { Breakpoint } from "@omni/types/enums/breakPoint.enum";
import { cn } from "@omni/utils/styles";

import { Delivery } from "@/components/Product/ECommerce/components/delivery/delivery.container";
import { Pricing } from "@/components/Product/ECommerce/components/pricing/pricing.container";

export const ECommerceComponent = () => {
    const { isBoxArticle, isAdditionalService } = useECommerceProduct();

    return (
        <>
            <ECommerce.OrderButton>
                <StickyAction
                    stickyActionElement={StickyActionElement.AddToCartButton}
                    hiddenBreakpoint={Breakpoint.md}
                >
                    <ECommerce.OrderButton.Button
                        color={"secondary"}
                        fullWidth={true}
                        {...getTagIdFor("ecommerce-order-button-sticky")}
                    />
                </StickyAction>
            </ECommerce.OrderButton>
            <div
                className={cn(
                    "tw:bg-grey tw:border-grey-input tw:border tw:rounded-sm tw:p-4 tw:mb-6"
                )}
            >
                <ECommerce.SoldOutStamp />
                <div>
                    <Pricing />
                    <ECommerce.Variants />
                    <Delivery />
                </div>
                {!isAdditionalService && (
                    <div className={cn("tw:flex tw:items-center tw:mt-2")}>
                        {!isBoxArticle && <ECommerce.Compare />}
                    </div>
                )}
            </div>
            <ECommerce.StorPickers.Info />
            <ECommerce.StorPickers.Select />
        </>
    );
};
